import React, { useEffect, useState } from 'react';

import * as yup from 'yup';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    TextField,
    Grid,
    Button,
    Box,
    Typography,
    Link,
    InputAdornment,
    IconButton
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useFormik } from 'formik';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme } from '../components/layout/Style';
import { login } from '../store/actions/authActions';

import Logo from '../assets/images/logo_branca_passarela_44.png';

function Auth(props) {

    const { login, userError } = props;
    const [showPassword, setShowPassword] = useState(false);
    const [mensagemErroLogin, setMensagemErroLogin] = useState({});

    useEffect(() => {
        setMensagemErroLogin(userError);
    }, [userError]);

    const validationSchema = yup.object({
        email: yup.string()
            .required('Campo obrigatório'),
        password: yup.string()
            .required('Campo obrigatório'),
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            login(values)
        },
    });

    const handleClickShowPassword = () => {
        setShowPassword((show) => !show)
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                color='primary'
                sx={{
                    width: '100vw',
                    height: '100vh',
                    bgcolor: '#F4ECE4',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        minHeight: '100vh'
                    }}
                >
                    <Grid item xs={8} sm={3}>
                        <Box component="section" sx={{
                            p: 2,
                            border: '1px dashed grey',
                            bgcolor: '#E2725B',
                        }}>
                            <Grid container >
                                <Grid
                                    container
                                    pt={2}
                                    sx={{ paddingTop: '5px', paddingBottom: '5px' }}
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Grid item xs={12} md={6}>
                                        <Box
                                            style={{ marginBottom: '40px', marginTop: '40px' }}
                                            component="img"
                                            src={Logo}
                                            alt="Passarela 44"
                                            sx={{
                                                width: '100%',     // ocupa toda a largura do Grid
                                                height: 'auto',    // mantém proporção original
                                                maxWidth: 250,     // opcional: limita tamanho máximo
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <form onSubmit={formik.handleSubmit} autoComplete='off' style={{ width: 'inherit' }}>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                id='email'
                                                name='email'
                                                label='E-mail'
                                                variant='outlined'
                                                color='secondary'

                                                placeholder='Informe seu e-mail para login'
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                error={formik.touched.email && Boolean(formik.errors.email)}
                                                helperText={formik.touched.email && formik.errors.email} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                id='password'
                                                name='password'
                                                label='Senha'
                                                variant='outlined'
                                                color='secondary'

                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                error={formik.touched.password && Boolean(formik.errors.password)}
                                                helperText={formik.touched.password && formik.errors.password}
                                                type={showPassword ? 'text' : 'password'}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label={
                                                                    showPassword ? 'hide the password' : 'display the password'
                                                                }
                                                                onClick={handleClickShowPassword}
                                                                onMouseDown={handleMouseDownPassword}
                                                                onMouseUp={handleMouseUpPassword}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                }} />
                                        </Grid>
                                        <Grid item xs={12}
                                            style={{
                                                display: `${mensagemErroLogin.msg ? '' : 'none'}`,
                                                opacity: 0.9,
                                                paddingBottom: '15px',
                                            }}>
                                            <Box
                                                component="section"
                                                sx={{
                                                    p: 1,
                                                    border: '1px dashed red',
                                                    bgcolor: '#F4ECE4'
                                                }}>
                                                {mensagemErroLogin.titulo}. {mensagemErroLogin.msg}
                                            </Box>
                                        </Grid>
                                        <Grid
                                            container
                                            pt={4}
                                            style={{ margin: '15px' }}
                                            alignItems="center"
                                            justifyContent="center"
                                            
                                        >
                                            <Button style={{margin: '5px', width: 100}} type='submit' color='secondary' variant='contained'>Entrar</Button>
                                            <Link href='/'><Button style={{margin: '5px', width: 100}} color='secondary' variant='contained' >Cancelar</Button></Link>
                                        </Grid>
                                        <Grid
                                            container
                                            pt={4}
                                            style={{ paddingBottom: '15px' }}
                                            direction="column"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Typography >
                                                <Link style={{ color: 'white' }} href='#' onClick={() => console.log('clicou no link')}>Esqueci a senha</Link>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    )
}
const mapStateToProps = state => ({
    userError: state.auth.userError
});
const mapDispatchToProps = dispatch => bindActionCreators({
    login
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Auth)